import sortBy from "lodash/sortBy";

import DatePickerWithError from "../../../inputs/DatePickerWithError";
import moment from "moment";

const inputs = {
  date: DatePickerWithError,
};

export default (customParamsJson, timezone) => ({
  groups: [
    {
      items: sortBy(Object.values(customParamsJson), ["sequenceIndex"]).map(
        ({ type, grid, sequenceIndex, ...param }) => ({
          input: {
            InputComponent: inputs[type],
            ignoreLabeledText: true,
            minDate: moment()
              .subtract(6, "months")
              .toDate(),
            maxDate: new Date(),
            timezone,
            ...param,
          },
          grid,
        })
      ),
    },
  ],
});
